(function() {
  console.log('[DR_DEBUG] Script d\'intégration Dr Free Gift démarré');
  
  // Désactiver explicitement le comportement de reload
  if (!window.freeGiftCartUpsellProAppDisableRefresh) {
    window.freeGiftCartUpsellProAppDisableRefresh = true;
  }
  
  // Fonction pour actualiser le contenu du panier sans ouvrir le drawer
  function refreshCartContents() {
    
    // Utiliser l'API Shopify pour obtenir l'état actuel du panier
    fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(cart => {
     
      
      // Ne pas essayer de forcer l'ouverture du drawer, seulement mettre à jour le contenu
      // si le drawer est déjà ouvert
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.classList.contains('active')) {
        
        // Utiliser l'API sections pour obtenir le HTML à jour
        fetch(`${routes.cart_url}?section_id=cart-drawer`, {
          method: 'GET'
        })
        .then(response => response.text())
        .then(html => {
          // Extraire le contenu pertinent
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Mettre à jour le contenu du drawer cart
          const cartDrawerItems = document.querySelector('cart-drawer-items');
          if (cartDrawerItems) {
            // Trouver le nouveau contenu dans la réponse
            const newCartDrawerItems = doc.querySelector('cart-drawer-items');
            if (newCartDrawerItems) {
              // Remplacer le contenu
              cartDrawerItems.innerHTML = newCartDrawerItems.innerHTML;
              console.log('[DR_DEBUG] Contenu du drawer cart mis à jour avec succès');
              
              // Émettre un événement pour signaler la mise à jour
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            }
          }
        })
        .catch(error => {
          console.error('[DR_DEBUG] Erreur lors de la mise à jour du contenu du drawer cart:', error);
        });
      } else {
        console.log('[DR_DEBUG] Le drawer cart n\'est pas ouvert, pas besoin de le mettre à jour');
      }
      
      // Mettre à jour le compteur du panier
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        fetch(`${routes.cart_url}?section_id=cart-icon-bubble`, {
          method: 'GET'
        })
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCartIconBubble = doc.getElementById('cart-icon-bubble');
          if (newCartIconBubble) {
            cartIconBubble.innerHTML = newCartIconBubble.innerHTML;
            console.log('[DR_DEBUG] Compteur du panier mis à jour avec succès');
          }
        })
        .catch(error => {
          console.error('[DR_DEBUG] Erreur lors de la mise à jour du compteur du panier:', error);
        });
      }
    })
    .catch(error => {
      console.error('[DR_DEBUG] Erreur lors de la récupération des données du panier:', error);
    });
  }
  
  // Attendre que le document soit chargé
  document.addEventListener('DOMContentLoaded', function() {
    // Attendez que l'application Dr Free Gift soit chargée
    const checkAppLoaded = setInterval(function() {
      
      if (window.freeGiftCartUpsellProApp) {
        clearInterval(checkAppLoaded);
      
        
        // Chercher la fonction updateCartState dans différents emplacements possibles
        let updateCartStatePath = '';
          
          // Solution alternative: surveiller les mutations du DOM
          const cartObserver = new MutationObserver(function(mutations) {
            let shouldRefresh = false;
            
            for (let mutation of mutations) {
              if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                shouldRefresh = true;
                break;
              }
            }
            
            if (shouldRefresh) {
              setTimeout(refreshCartContents, 500);
              // Déconnecter temporairement l'observateur pour éviter les boucles infinies
              cartObserver.disconnect();
              setTimeout(() => {
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                  cartObserver.observe(cartDrawer, { childList: true, subtree: true });
                }
              }, 4000); // Reconnecter après le rafraîchissement
            }
          });
          
          // Observer le contenu du drawer cart
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartObserver.observe(cartDrawer, { childList: true, subtree: true });
            console.log('[DR_DEBUG] Observation du drawer cart mise en place');
          }
        
       
        
     
      }
    }, 500);
  });
  
})();